import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import authReducer from './auth';
import foodReducer from './food';
import dialogReducer from './dialog';
import historyReducer from './history';
import financeReducer from './finance';
import compReducer from './compAct';
import docsReducer from './docs';

export default combineReducers({
    routing: routerReducer,
    auth: authReducer,
    food: foodReducer,
    dialog: dialogReducer,
    history: historyReducer,
    finance: financeReducer,
    comp: compReducer,
    docs: docsReducer
});



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/index.js
 **/